var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerA(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1995 32.5899H28.8095V26.6999C27.2095 29.3199 22.0295 32.5899 16.2695 32.5899C7.49953 32.5899 0.269531 25.2899 0.269531 16.5899C0.269531 7.8899 7.49953 0.649902 16.2695 0.649902C22.0295 0.649902 27.2095 3.8499 28.8095 6.4699V0.709902H32.1995V32.5799V32.5899ZM28.8095 16.5899C28.8095 9.6099 23.2395 4.0499 16.2695 4.0499C9.29953 4.0499 3.65954 9.6199 3.65954 16.5899C3.65954 23.5599 9.22953 29.1999 16.2695 29.1999C23.3095 29.1999 28.8095 23.6299 28.8095 16.5899Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerA);
export default __webpack_public_path__ + "static/media/LOWER_A.4277bdb00cbfdf9bb56ca39c15053a4e.svg";
export { ForwardRef as ReactComponent };